import React, { useState } from "react";


import {
  FaShoppingBag,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function RetailIndustryPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "In-Store Operations & Customer Engagement",
      points: [
        "Smart Shelf Monitoring Agent",
        "Queue Management Agent",
        "Virtual Shopping Assistant Agent",
        "In-Store Navigation Agent",
        "Foot Traffic Analysis Agent",
      ],
    },

    {
      title: "Personalized Customer Experience",
      points: [
        "Product Recommendation Agent",
        "Personal Stylist Agent (Fashion)",
        "Voice Shopping Agent",
        "Customer Sentiment Agent",
        "Price Sensitivity Prediction Agent",
      ],
    },

    {
      title: "Inventory & Supply Chain Management",
      points: [
        "Demand Forecasting Agent",
        "Real-Time Inventory Sync Agent",
        "Vendor Management Agent",
        "Returns Optimization Agent",
        "Supply Chain Disruption Agent",
      ],
    },

    {
      title: "E-Commerce & Omnichannel Retail",
      points: [
        "Visual Search Agent",
        "Cart Abandonment Recovery Agent",
        "Dynamic Pricing Agent",
        "Product Content Generation Agent",
        "Multi-Channel Sync Agent",
      ],
    },

    {
      title: "Logistics, Fulfillment & Delivery",
      points: [
        "Delivery Route Optimization Agent",
        "Last-Mile Delivery Agent",
        "Warehouse Allocation Agent",
        "Courier Assignment Agent",
        "Inventory Redistribution Agent",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .retail-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .retail-hero {
          background: #173b8f;
          width: 100%;
        }

        .retail-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .retail-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .retail-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .retail-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .retail-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .retail-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .retail-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .retail-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .retail-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .retail-card-header.active {
          background: #173b8f;
        }

        .retail-card-header.inactive {
          background: #ffffff;
        }

        .retail-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .retail-card-title.active {
          color: #ffffff;
        }

        .retail-card-title.inactive {
          color: #173b8f;
        }

        .retail-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .retail-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .retail-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .retail-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .retail-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .retail-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .retail-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .retail-hero-inner {
            padding: 32px 0px;
          }

          .retail-title {
            font-size: 30px;
          }

          .retail-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .retail-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .retail-icon-box {
            width: 40px;
            height: 40px;
          }

          .retail-icon-box svg {
            font-size: 18px;
          }

          .retail-title {
            font-size: 26px;
          }

          .retail-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .retail-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .retail-card-header {
            padding: 12px 16px;
          }

          .retail-card-title {
            font-size: 15px;
          }

          .retail-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .retail-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .retail-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .retail-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .retail-icon-box svg {
            font-size: 16px;
          }

          .retail-title {
            font-size: 21px;
          }

          .retail-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .retail-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .retail-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .retail-card-header {
            padding: 10px 14px;
          }

          .retail-card-title {
            font-size: 14px;
          }

          .retail-card-content {
            padding: 14px 14px;
          }

          .retail-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .retail-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .retail-point-check svg {
            font-size: 9px;
          }

          .retail-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .retail-title {
            font-size: 18px;
          }

          .retail-card-title {
            font-size: 13px;
          }

          .retail-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="retail-wrapper">
        {/* HERO SECTION */}
        <div className="retail-hero">
          <div className="retail-hero-inner">
            <div className="retail-hero-top">
              <div className="retail-icon-box">
                <FaShoppingBag />
              </div>

              <h1 className="retail-title">The Retail Industry</h1>
            </div>

            <p className="retail-description">
              Retail spans physical and online shopping experiences.
              From personalized recommendations and inventory
              automation to customer service chatbots and smart
              checkout, AI agents are transforming how products are
              marketed, sold, and delivered to consumers.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="retail-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="retail-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`retail-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`retail-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="retail-chevron-active" />
                  ) : (
                    <FaChevronDown className="retail-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="retail-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="retail-point-row">
                        <div className="retail-point-check">
                          <FaCheck />
                        </div>

                        <p className="retail-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default RetailIndustryPage;
